namespace Portico.Tfs {
    angular.module('app').directive('tfsReleaseView', [
        function() {
            interface State {
                release: Release.List.Value;
                environment: Release.Get.Environment;
                panel: { [index: string]: boolean };
                releaseUrl: string;
                build?: Build.Get.Response;
                commitUrl?: string;
                compareTo(sha: string): string;
            }

            class Controller {
                releases: Release.List.Value[];
                current: State;
                successful: State;
                build: Build.Get.Response;
                environment: string;
                portal: Portico.Models.Setup.Portal;
                portico: {
                    release: Release.List.Value;
                    environment: Release.Get.Environment;
                    build?: Build.Get.Response;
                };

                name: string;

                constructor(
                    private $scope: ng.IScope,
                    private $attrs: ng.IAttributes,
                    private tfsService: TfsService
                ) {
                    this.name = this.$attrs['name'];
                    $scope.$on('tfs:update', () => this.update());
                }

                releaseState(
                    release: Release.List.Value,
                    environment: Release.Get.Environment
                ): State {
                    const result: State = {
                        compareTo(sha: string) {
                            if (!this.build) return '';
                            return (
                                this.build &&
                                `https://tfs.trialcard.com/DevCollection/_git/Portico/branches?baseVersion=GC${sha}&targetVersion=GC${
                                    this.build.sourceVersion
                                }&_a=commits`
                            );
                        },
                        release,
                        environment,
                        panel: this.panel(environment),
                        releaseUrl: this.releaseUrl(release),
                    };
                    const build = this.tfsService.build
                        .get(release.artifacts[0].definitionReference.version.id as any)
                        .then(build => {
                            result.build = build;
                            result.commitUrl = this.commitUrl(build);
                        });
                    return result;
                }

                panel(environment: Release.Get.Environment) {
                    return {
                        'panel-success': environment.status === 'succeeded',
                        'panel-info':
                            environment.status === 'inProgress' ||
                            environment.status === 'notStarted',
                        'panel-danger': environment.status === 'rejected',
                        'panel-warning': environment.status === 'partiallySucceeded',
                    };
                }

                releaseUrl(release: Release.List.Value) {
                    return release && release._links.web.href;
                }

                commitUrl(build: Build.Get.Response) {
                    return (
                        build &&
                        `https://tfs.trialcard.com/DevCollection/Portico/Team%20Portals%20to%20Go/_git/Portico/commit/${
                            build.sourceVersion
                        }`
                    );
                }

                compareTo(build: Build.Get.Response, sha: string) {}

                update() {
                    this.current = null;
                    this.successful = null;
                    for (let value of this.releases || []) {
                        if (this.current && this.successful) break;
                        if (this.current && this.current.environment.status === 'succeeded') break;

                        for (let environment of value.environments) {
                            if (environment.name.toLowerCase() === this.environment.toLowerCase()) {
                                if (!this.current) {
                                    this.current = this.releaseState(value, environment);
                                }
                                if (!this.successful && environment.status === 'succeeded') {
                                    if (this.current && value.id === this.current.release.id) break;

                                    this.successful = this.releaseState(value, environment);
                                }
                            }
                        }
                    }

                    for (const release of (this.tfsService.porticoReleases || []) as Release.List.Value[]) {
                        const environment = _.find(release.environments, x =>
                            x.name.toLowerCase().startsWith(this.environment.toLowerCase())
                        );
                        if (environment && environment.status === 'succeeded') {
                            const artifact = _.find(
                                release.artifacts,
                                x =>
                                    x.definitionReference.definition.id.toString() ===
                                    this.tfsService.settings.porticoBuildDefinitionId
                            );
                            this.tfsService.build
                                .get(artifact.definitionReference.version.id as any)
                                .then(
                                    build =>
                                        (this.portico = { environment, release, build })
                                );
                            break;
                        }
                    }
                }

                $onInit() {
                    this.$scope.$watch<Release.List.Value[]>(
                        'ctrl.releases',
                        (releases, oldReleases) => {
                            if (releases) this.update();
                        }
                    );
                }
            }
            return {
                scope: { releases: '=', environment: '<', portal: '=' },
                bindToController: true,
                controllerAs: 'ctrl',
                template: `
<div>
    <div class="panel" ng-class="ctrl.current.panel">
        <div class="panel-heading">
            {{ ctrl.name }}
            <div class="pull-right" style="margin-top: -4px;">
                <a class="btn btn-default btn-sm" title="view commit" style="display: inline-block; margin-left: 4px;" ng-href="{{ctrl.current.commitUrl}}" target="_blank">
                    <i class="fab fa-git"></i>
                </a>
                <a ng-if="ctrl.portico" class="btn btn-default btn-sm" title="view compare" style="display: inline-block; margin-left: 4px;" ng-href="{{ctrl.successful.compareTo(ctrl.portico.build.sourceVersion)}}" target="_blank">
                    <i class="fas fa-code-branch"></i>
                </a>
                <a class="btn btn-default btn-sm" title="view build" href="{{ ctrl.current.releaseUrl }}" target="_blank">
                    <i class="fas fa-terminal"></i>
                </a>
            </div>
        </div>
        <table class="table">
            <tr>
                <td>Name:</td>
                <td><a ng-href="{{ ctrl.current.releaseUrl }}" target="_blank">{{ ctrl.current.release.name }}</a></td>
            </tr>
            <tr>
                <td>Status:</td>
                <td>{{ ctrl.current.environment.status }}</td>
            </tr>

            <tr>
                <td>Commit:</td>
                <td><a ng-href="{{ctrl.current.commitUrl}}" target="_blank">{{ ctrl.current.build.sourceVersion | limitTo:8 }}</a></td>
            </tr>
            <tr ng-if="ctrl.portico">
                <td>Compare:</td>
                <td><a ng-href="{{ctrl.current.compareTo(ctrl.portico.build.sourceVersion)}}" target="_blank">{{ ctrl.portico.build.sourceVersion | limitTo:8}} <=> {{ ctrl.current.build.sourceVersion | limitTo:8 }}</a></td>
            </tr>
        </table>
    </div>
    <div class="panel" ng-class="ctrl.successful.panel" ng-if="ctrl.successful">
        <div class="panel-heading">
            Last Successful
            <div class="pull-right" style="margin-top: -4px;">
                <a class="btn btn-default btn-sm" title="view commit" style="display: inline-block; margin-left: 4px;" ng-href="{{ctrl.successful.commitUrl}}" target="_blank">
                    <i class="fab fa-git"></i>
                </a>
                <a ng-if="ctrl.portico" class="btn btn-default btn-sm" title="view compare" style="display: inline-block; margin-left: 4px;" ng-href="{{ctrl.successful.compareTo(ctrl.portico.build.sourceVersion)}}" target="_blank">
                    <i class="fas fa-code-branch"></i>
                </a>
                <a class="btn btn-default btn-sm" alt="view release" ng-href="{{ ctrl.successful.releaseUrl }}" target="_blank">
                    <i class="fas fa-terminal"></i>
                </a>
            </div>
        </div>
        <table class="table">
            <tr>
                <td>Name:</td>
                <td><a ng-href="{{ ctrl.successful.releaseUrl }}" target="_blank">{{ ctrl.successful.release.name }}</a></td>
            </tr>
            <tr>
                <td>Status:</td>
                <td>{{ ctrl.successful.environment.status }}</td>
            </tr>
            <tr>
                <td>Commit:</td>
                <td><a ng-href="{{ctrl.successful.commitUrl}}" target="_blank">{{ ctrl.successful.build.sourceVersion | limitTo:8 }}</a></td>
            </tr>
            <tr ng-if="ctrl.portico">
                <td>Compare:</td>
                <td><a ng-href="{{ctrl.successful.compareTo(ctrl.portico.build.sourceVersion)}}" target="_blank">{{ ctrl.portico.build.sourceVersion | limitTo:8}} <=> {{ ctrl.successful.build.sourceVersion | limitTo:8 }}</a></td>
            </tr>
        </table>
    </div>
</div>`,
                controller: ['$scope', '$attrs', 'tfsService', Controller as any],
            };
        },
    ]);
}
